/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type CustomSettingsType from '@jira/spa-apps__project-settings-custom-filters/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyCustomFiltersSettings: LazyComponent<() => React.JSX.Element | null> =
	lazyForPaint<typeof CustomSettingsType>(
		() =>
			import(
				/* webpackChunkName: "async-project-settings-custom-filters", jiraSpaEntry: "async-project-settings-custom-filters" */ '@jira/spa-apps__project-settings-custom-filters/src/index.tsx'
			),
	);

const AsyncCustomFiltersSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomFiltersSettings}
		pageId="project-settings-custom-filters"
		shouldShowSpinner
	/>
);

export default AsyncCustomFiltersSettings;
